import { createAsyncThunk } from "@reduxjs/toolkit";
import { SearchParams, ListParams, DeleteParams, CustomerAccount, UpdateContactsParams, SearchAssignmentsParams } from "../model/contact";
import * as services from "../services/contactService";
import { AxiosError } from "axios";


export const fetchContacts = createAsyncThunk("contactManager/fetchContacts", (params: ListParams) =>
    services.fetchContacts(params)
);

export const fetchContactById = createAsyncThunk("contactDetail/fetchContactById", (id?: string) =>
    services.fetchContactById(id)
);

export const searchContacts = createAsyncThunk("contactManager/searchContacts", (params: SearchParams) =>
    services.searchContacts(params)
);

export const updateContact = createAsyncThunk(
    "contactDetail/updateContact",
    async (contact: any, { rejectWithValue }) => {
        try {
            const response = await services.updateContact(contact);
            return response;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const deleteContacts = createAsyncThunk(
    "contactManager/deleteContact",
    async (deleteParams: DeleteParams): Promise<any> => {
        await services.deleteContacts(deleteParams.contactIds);
        if (deleteParams.query === "" || deleteParams.query === undefined) {
            return services.fetchContacts({
                sortField: deleteParams.sortField,
                sortType: deleteParams.sortType,
                startIndex: deleteParams.startIndex,
                recordsToRetrieve: deleteParams.recordsToRetrieve,
                type: deleteParams.type
            });
        } else {
            return services.searchContacts({
                query: deleteParams.query,
                sortField: deleteParams.sortField,
                sortType: deleteParams.sortType,
                startIndex: deleteParams.startIndex,
                recordsToRetrieve: deleteParams.recordsToRetrieve,
                type: deleteParams.type
            });
        }
    }
);

export const fetchCurrencies = createAsyncThunk("contactDetail/fetchCurrencies", () => services.fetchCurrencies());

export const fetchLanguages = createAsyncThunk("contactDetail/fetchLanguages", () => services.fetchLanguages());

export const fetchAddressesByContactId = createAsyncThunk(
    "contactDetail/fetchAddressesByContactId",
    (contactId: string) => services.fetchAddressesByContactId(contactId)
);

export const fetchOrganizations = createAsyncThunk("contactDetail/fetchOrganizations", () =>
    services.fetchOrganizations()
);

export const fetchUserByContactId = createAsyncThunk("contactDetail/fetchUserByContactId", (contactId: string) =>
    services.fetchUserByContactId(contactId)
);

export const createCustomerAccount = createAsyncThunk(
    "contactDetail/createCustomerAccount",
    async (account: CustomerAccount) => {
        let result = await services.createCustomerAccount(account);
        let user = await services.fetchUserByContactId(account.contactId);
        return { errors: result.errors, account: user };
    }
);

export const fetchUserAccountAssignments = createAsyncThunk(
    "contactManager/fetchUserAccountAssignments",
    (contactId: string) => services.fetchUserAccountAssignments(contactId)
);

export const searchAvailableUserAccountAssignments = createAsyncThunk(
    "contactManager/searchAvailableUserAccountAssignments",
    (searchParams: SearchAssignmentsParams) => services.searchAvailableUserAccountAssignments(searchParams)
);

export const updateUserAccountAssignments = createAsyncThunk(
    "contactManager/addUserAccountAssignments",
    async (params: UpdateContactsParams) => {
        await services.UpdateUserAccountAssignments(params);
        const contacts = services.fetchUserAccountAssignments(params.contactId);
        return contacts;
    }
);

